import React, { Component } from "react";
// import Avatar from "@mui/material/Avatar";
import moment from "moment";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { Menu, MenuItem } from "@mui/material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import StoreIcon from "@mui/icons-material/Store";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Button } from "react-bootstrap";
import { Subscriptions } from "@mui/icons-material";
import DeleteUserModal from "../../Modal/DeleteUserModal";
import ManageUserService from "../../../api/ManageUserService";
import { Toaster, toast } from "react-hot-toast";
import SubscrptionDetailsModal from "../../Modal/SubscrptionDetailsModal";
import Loader from "../../../components/Loader";

class AdminEmployeeGrid extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openModal: false,
      subscriptionData: {},
      description: "",
      title: "",
      totalvalue: {},
      exactadata: {},
      contentPage: false,
      clickedIndex: false,
      opendeleteproductDialogue: false,
      openSubscriptionModal: false,
      loader : false,
    };
  }

  render() {
    console.log("props", this.state);
    const { contentPage, clickedIndex } = this.state;
    const { componentList } = this.props;

    return (
      <>
      {this.state.loader && 
      <Loader />}
        <Toaster />
        {!contentPage ? (
          <div className="adjust-grid-admin-conatiner">
            {this.state.opendeleteproductDialogue && (
              <DeleteUserModal
                handleClose={this.handleClose}
                deleteUser={this.deleteUser}
                deleteEmployer={true}
              />
            )}
            {this.state.openSubscriptionModal && (
              <SubscrptionDetailsModal
                subscription={this.state.subscriptionData}
                handleClose={this.handleCloseSubscription}
              />
            )}
            
            <div className="Center-the-Grid-admin">
              <div className="adjust-grid-container">
                <div className="">
                  {this.props.userList.length > 0 ? (
                    <table className="user-table admin-table">
                      <thead>
                        <tr>
                          <th>Employer Name</th>
                          <th>Employees</th>
                          <th>Email</th>
                          {/* <th>Phone Number</th> */}
                          <th>Purchase date and time</th>
                          <th>Joined date</th>
                          <th>Last active</th>
                          <th>Plaform</th>
                          {/* <th>Createdby</th> */}
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.props.userList.map((item) => {
                          return (
                            <tr key={item.id}>
                              <td>
                                {item.firstName +
                                  (item.lastName && item.lastName !== ""
                                    ? " " + item.lastName
                                    : "")}
                              </td>
                              <td>{item.employees}</td>
                              <td>{item.mailID}</td>
                              {/* <td>{item.phone_no ?? "Not provided"}</td> */}
                              <td>
                              {item.purchaseDate ? moment(item.purchaseDate).format("MMMM DD, YYYY, hh:mm A") : "No purchase recorded"}
                              </td>
                              <td>
                                {moment(item.createdDate).format("MMMM DD, YYYY")}
                              </td>
                              <td>
                                {item.lastLogin ? moment(item.lastLogin).format("MMMM DD, YYYY, hh:mm A") : "No login recorded"}
                              </td>
                              <td>{item.platform === "ios" ? "iOS" : item.platform === "android" ? "Android" : "No Subscription"}</td>
                              {/* <td>{item.createByAdmin ? "Admin" : "Self"}</td> */}
                              {/* <td>
                                <Button className="formshop-btn">Check</Button>
                              </td> */}

                              <td>
                                {
                                  <>
                                    <MoreHorizIcon
                                      className="cursor-pointer"
                                      onClick={(event) =>
                                        this.handleFilterClick(event, item)
                                      }
                                    />{" "}
                                    <Menu
                                      anchorEl={this.state.anchorEl}
                                      open={Boolean(this.state.anchorEl)}
                                      onClose={this.handleFilterClose2}
                                      className="exclude-menu"
                                    >
                                      <MenuItem
                                        onClick={(e) =>
                                          this.handleFilterClose("edit", item)
                                        }
                                      >
                                        <EditOutlinedIcon />{" "}
                                        <span className="inisde-the-action">
                                          Edit
                                        </span>
                                      </MenuItem>

                                      <MenuItem
                                        onClick={() =>
                                          this.handleFilterClose("delete")
                                        }
                                      >
                                        <DeleteOutlinedIcon />{" "}
                                        <span className="inisde-the-action">
                                          Delete
                                        </span>
                                      </MenuItem>
                                      <MenuItem
                                        onClick={() =>
                                          this.handleFilterClose("subscription")
                                        }
                                      >
                                        <StoreIcon />
                                        <span className="inisde-the-action">
                                          Check Subscription
                                        </span>
                                      </MenuItem>

                                      {/* <MenuItem
                                        onClick={() => this.handleClick(item)}
                                      >
                                        <VisibilityIcon />{" "}
                                        <span className="inisde-the-action">
                                          View Record
                                        </span>
                                      </MenuItem> */}
                                      <MenuItem
                                        onClick={() =>
                                          this.handleFilterClose("employees")
                                        }
                                      >
                                        <AssignmentIndIcon />{" "}
                                        <span className="inisde-the-action">
                                          View Employees
                                        </span>
                                      </MenuItem>
                                    </Menu>
                                  </>
                                }
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  ) : (
                    <div className="no-data-found">No Data Found</div>
                  )}
                </div>
              </div>
            </div>
          </div>
        ) : (
          <>
            <div className="card-container-2">
              {componentList.map((item, index) => (
                <div
                  className={`card${clickedIndex === index ? "clicked" : "-2"}`}
                  key={index}
                  onClick={() => this.handleClick2(item, index)}
                >
                  <img src={item.icon} alt="Icon" />

                  <h2>{item.name}</h2>
                </div>
              ))}
            </div>
          </>
        )}
      </>
    );
  }

  // handleModalClose2 = () => {
  //   this.setState({ isModalOpen: false });
  // };

  handleFilterClose2 = () => {
    this.setState({
      anchorEl: null,
    });
  };
  handleFilterClick = (event, data) => {
    console.log("event", event, data);

    this.setState(
      {
        anchorEl: event.target,
        selectedEditData: data,
        showViewServiceRecord: data.allow,
      },
      () => {
        console.log("selectedEditData", this.state.selectedEditData);
      }
    );
  };

  handleFilterClose = (getState) => {
    // console.log("employeerId:::::", employeerId, this.state.selectedEditData);
    // alert("fun")
    if (getState === "edit") {
      this.props.ActiveEdit(this.state.selectedEditData);
      this.handleFilterClose2();
    } else if (getState === "delete") {
      // console.log("delete::::",this.state.selectedEditData);
      this.setState({
        opendeleteproductDialogue: true,
        anchorEl: null,
      });
    } else if (getState === "subscription") {
      // this.props.employerId(true);
      this.setState({
        // opendeleteproductDialogue: true,
        anchorEl: null,
        loader: true,
      });
      this.checkSubscriptionStatus();
    } else if (getState === "employees") {
      sessionStorage.setItem("authID", this.state.selectedEditData.id);
      this.props.history.replace(`/Employee`);
    }
  };

  // handleCheckSubscription =(getState) =>{

  // }

  handleClick = (item) => {
    console.log("item", item);

    sessionStorage.setItem("authID", item.id);

    this.setState(
      {
        contentPage: true,
      },
      () => {
        this.props.history.replace(`/Admin-Content`);
      }
    );
  };

  handleClick2 = (item) => {
    console.log("item name:", item.name);

    this.setState(
      {
        clickedIndex: item,
      },
      () => {
        this.props.history.replace(`/${item.name}`);
      }
    );
  };

  handleClose = () => {
    this.setState({ opendeleteproductDialogue: false });
  };

  handleCloseSubscription = () => {
    this.setState({ openSubscriptionModal: false });
  };

  deleteUser = () => {
    let obj = {
      id: this.state.selectedEditData.id,
    };

    ManageUserService.deleteUser(obj).then((response) => {
      if (response.data) {
        this.handleClose();
        this.props.onLoad();
      }
    });
  };

  checkSubscriptionStatus = () => {
    const obj = {
      id: this.state.selectedEditData.id,
    };

    ManageUserService.checkSubscriptionStatus(obj)
      .then((response) => {
        if (response.data.status === 1) {
          const { platform, latestReceipt } = response.data.data;
          console.log("SUBSCRIPTION DATA", platform, latestReceipt);
          let subscription = {
            name:
              this.state.selectedEditData.firstName +
              " " +
              this.state.selectedEditData.lastName,
              platform
          };
          if (platform === "android") {
            const parsedData = JSON.parse(latestReceipt);
            const expiryDate = new Date(parseInt(parsedData.expiryTimeMillis));


            subscription.productId = response.data.data.product_id;
            subscription.isTrialPeriod = parsedData?.paymentState === 2 ? true : false;
            subscription.purchaseDate = moment(
              parseInt(parsedData.startTimeMillis)
            ).format("YYYY-MM-DD HH:mm:ss");
            subscription.expiryDate = moment(
              parseInt(parsedData.expiryTimeMillis)
            ).format("YYYY-MM-DD HH:mm:ss");

            if (moment(expiryDate).isAfter()) {
              // this.moveToUsersAuthorizedPage();
              console.log("The subscription is still active.");
              subscription.status = "active";
            } else {
              // this.handleSubscriptionExpired();
              subscription.status = "expired";
            }
          } else if (platform === "ios") {
            // alert("ios");
            // console.log("The subscription is still active", response.data.data.);
            subscription.productId = latestReceipt.product_id;
            subscription.isTrialPeriod = JSON.parse(latestReceipt.is_trial_period);
            subscription.purchaseDate = moment
              .utc(latestReceipt.purchase_date, "YYYY-MM-DD HH:mm:ss [Etc/GMT]")
              .format("YYYY-MM-DD HH:mm");
            subscription.expiryDate = moment
              .utc(latestReceipt.expires_date, "YYYY-MM-DD HH:mm:ss [Etc/GMT]")
              .format("YYYY-MM-DD HH:mm");

            const expiryDate = new Date(
              parseInt(latestReceipt.expires_date_ms)
            );
            // console.log("The subscription is still active", expiryDate);
            const currentDate = new Date();

            if (expiryDate > currentDate) {
              // this.moveToUsersAuthorizedPage();
              console.log("The subscription is still active.");
              subscription.status = "active";
            } else {
              console.log("The subscription has expired.");
              subscription.status = "expired";
              // this.handleSubscriptionExpired();
            }
          } else {
            console.log("Unknown platform error.");
            // AuthService.removeAuth();
          }
          console.log("subscription:::::1", subscription);
          this.setState(
            {
              subscriptionData: subscription,
            },
            () => {
              console.log("subscription:::::2", subscription);
              this.setState({
                openSubscriptionModal: true,
                loader: false,
              });

            }
          );
        } else if (response.data.status === -2) {
          console.log(response.data.message);
          this.setState({loader: false});
          toast.error("No Subscription Available.");
        } else if (response.data.status === -1) {
          console.log(response.data.message);
          toast.error("No Active Subscription.");
          this.setState({loader: false});
        } else {
          console.log(response.data.message);
          toast.error("Something went wrong.");
          this.setState({loader: false});
        }
      })
      .catch((error) => {
        console.error("Network error:", error);
        toast.error("Something went wrong.");
        this.setState({loader: false});
        // toast.error("Network error. Please try again later.");
      });
  };
}

const mapStateToProps = function (state) {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(AdminEmployeeGrid));
